import React, { useEffect, useRef, useState } from "react";
import * as S from "./dropdown.style";
import { DropdownOption, DropdownProps } from "./dropdown.types";

const Dropdown: React.FC<DropdownProps> = ({
	options,
	onSelect,
	placeholder = "Selecione uma opção",
}) => {
	const [isOpen, setIsOpen] = useState(false);
	const [selectedLabel, setSelectedLabel] = useState(placeholder);
	const dropdownRef = useRef<HTMLDivElement>(null);

	const handleSelect = (option: DropdownOption) => {
		setSelectedLabel(option.label);
		onSelect(option.value);
		setIsOpen(false);
	};

	useEffect(() => {
		const handleClickOutside = (event: MouseEvent) => {
			if (
				dropdownRef.current &&
				!dropdownRef.current.contains(event.target as Node)
			) {
				setIsOpen(false);
			}
		};

		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, []);

	return (
		<S.DropdownContainer ref={dropdownRef}>
			<S.DropdownButton onClick={() => setIsOpen(!isOpen)}>
				{placeholder}
				<S.Arrow>{isOpen ? "▲" : "▼"}</S.Arrow>
			</S.DropdownButton>

			{isOpen && (
				<S.DropdownList>
					{options.map((option: DropdownOption) => (
						<S.DropdownItem
							key={option.value}
							onClick={() => handleSelect(option)}
						>
							{option.label}
						</S.DropdownItem>
					))}
				</S.DropdownList>
			)}
		</S.DropdownContainer>
	);
};

export default Dropdown;
